import { createModel } from '@rematch/core';
import { RootModel } from '../root';
import effects from './auditEvents.effects';

const model = createModel<RootModel>()({
  state: {},
  effects
});

export default model;
